var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9981 5.95573C10.5851 5.95573 10.2321 5.81275 9.93929 5.52679C9.64643 5.24085 9.5 4.8971 9.5 4.49554C9.5 4.094 9.64706 3.75087 9.94119 3.46615C10.2353 3.18142 10.5889 3.03906 11.0019 3.03906C11.4149 3.03906 11.7679 3.18204 12.0607 3.468C12.3536 3.75394 12.5 4.09769 12.5 4.49925C12.5 4.90079 12.3529 5.24392 12.0588 5.52865C11.7647 5.81337 11.4111 5.95573 10.9981 5.95573ZM9.92857 18.0391V8.03906H12.0714V18.0391H9.92857Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.976d6cd6ef1c8e9ecc6aa0de5bec8cc1.svg";
export { ForwardRef as ReactComponent };